import { render, staticRenderFns } from "./BranchOverview.vue?vue&type=template&id=15c47fe6&scoped=true&"
import script from "./BranchOverview.vue?vue&type=script&lang=js&"
export * from "./BranchOverview.vue?vue&type=script&lang=js&"
import style0 from "./BranchOverview.vue?vue&type=style&index=0&id=15c47fe6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c47fe6",
  null
  
)

export default component.exports